import React, { FunctionComponent } from 'react'
import { Card } from 'antd'
import DeviceSearch from './DeviceSearch/DeviceSearch'

const SearchBar: FunctionComponent<any> = () => {
  return (
    <Card
      id={'search-bar'}
      style={{
        borderRadius: '10px',
        padding: 0,
        margin: 0,
        position: 'absolute',
        left: '10px',
        top: '10px',
        zIndex: 3
      }}
      styles={{
        body: {
          padding: '5px',
          margin: 0
        }
      }}
    >
      <DeviceSearch />
    </Card>
  )
}

export default SearchBar
